import { render, staticRenderFns } from "./LocalTenant.vue?vue&type=template&id=1d129a49&scoped=true"
import script from "./LocalTenant.vue?vue&type=script&lang=js"
export * from "./LocalTenant.vue?vue&type=script&lang=js"
import style0 from "./LocalTenant.vue?vue&type=style&index=0&id=1d129a49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d129a49",
  null
  
)

export default component.exports